import type { Dispatch, SetStateAction } from 'react';
import { createContext, useContext } from 'react';

export interface ContextMenuContextState<T> {
  data: T;
  setData: Dispatch<SetStateAction<T>>;
}

export const ContextMenuContext = createContext<ContextMenuContextState<any>>({} as never);

export function useContextMenu<T>() {
  return useContext<ContextMenuContextState<T>>(ContextMenuContext);
}
